{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -7.401388556740386,
              37.26571132283944
            ],
            [
              -5.499125051883169,
              36.0006762166944
            ],
            [
              -1.458957038273553,
              36.71666855445794
            ],
            [
              5.089590269558386,
              40.14894930137103
            ],
            [
              3.195637628659938,
              42.507109356667655
            ],
            [
              -2.8163798887649705,
              40.57181728447864
            ],
            [
              -5.685624901003649,
              38.95533721012288
            ],
            [
              -7.401388556740386,
              37.26571132283944
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}